import { useParams } from "react-router-dom";
import { useInfiniteSocialMediaFeed } from "../api/getFeed";
import { useInView } from "react-intersection-observer";
import SocialMediaPostCompact from "../components/SocialMediaPostCompact";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import MobileHeader from "../components/Layout/MobileHeader";
import SideBar from "../components/Layout/SideBar";
import SideBarSection from "../components/SideBarSection";
import SocialMediaThemes from "../components/SocialMediaThemes";
import Navbar from "../../../ui/blocks/Navbar";
import { useState, useEffect } from "react";
import { useModeratePost } from "../api/moderatePost";

const useStyles = makeStyles((theme) => ({
  main: {
    width: "min(100vw, 500px)",
    overflow: "visible",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: theme.spacing(1),
    "& > * > .post_compact_thumbnail_restrict": { minHeight: "350px" },
  },
  container: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    position: "relative",
  },
}));

export default function ModerateThemePage() {
  const { themeId } = useParams();
  const moderatePostM = useModeratePost();
  const [rejectPostId, setRejectPostId] = useState(null);
  const [reason, setReason] = useState("");
  const rejectPostDialogIsOpen = Boolean(rejectPostId);
  const closeRejectPostDialog = () => {
    setReason("");
    setRejectPostId(null);
  };
  const feedQuery = useInfiniteSocialMediaFeed({
    pageLength: 15,
    themeId: Number(themeId) * -1 || 10000,
  });
  const classes = useStyles();
  const bottomEl = useInView();
  const handleBottomEntersView = () => {
    if (feedQuery.hasNextPage && !feedQuery.isFetchingNextPage) {
      feedQuery.fetchNextPage();
    }
  };
  useEffect(() => {
    document.getElementById("navbar_container").style.position = "fixed";
    document.getElementById("navbar_toggle_button").style.marginTop = "-70px";
  }, []);
  useEffect(() => {
    if (bottomEl?.inView) {
      handleBottomEntersView();
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottomEl?.inView]);

  return (
    <div className={classes.container}>
      <main className={classes.main}>
        <MobileHeader />
        <Dialog
          open={rejectPostDialogIsOpen}
          close={closeRejectPostDialog}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Rejeitar postagem</DialogTitle>

          <DialogContent>
            <DialogContentText>
              <TextField
                className="w-full"
                multiline
                rows={4}
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeRejectPostDialog}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={() => {
                moderatePostM.mutate(
                  {
                    postId: rejectPostId,
                    reason,
                    action: "R",
                  },
                  {
                    onSuccess: () => {
                      closeRejectPostDialog();
                    },
                  }
                );
              }}
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        {feedQuery?.data?.pages?.map((page) => {
          return page.map((postData, index) => {
            return (
              <>
                <SocialMediaPostCompact
                  postData={postData}
                  key={`post-compact-${index}`}
                />
                <span className="flex flex-row w-full justify-between py-2">
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      setRejectPostId(postData.postagemid);
                    }}
                  >
                    Rejeitar
                  </Button>
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      moderatePostM.mutate({
                        postId: postData.postagemid,
                        reason: "",
                        action: "A",
                      });
                    }}
                  >
                    Aprovar
                  </Button>
                </span>
                <Divider sx={{ marginBottom: 2 }} />
              </>
            );
          });
        })}
        <div
          ref={bottomEl.ref}
          className="h-[350px] flex-row w-full justify-center flex item-center content-center"
        >
          {feedQuery.hasNextPage ? (
            <CircularProgress />
          ) : (
            <Typography variant="subtitle2">
              Fim das postagens a serem analisadas desse tema
            </Typography>
          )}
        </div>
      </main>
      <SideBar>
        <SideBarSection title="Temas">
          <SocialMediaThemes />
        </SideBarSection>
      </SideBar>
      <div className="fixed left-0 top-[64px]">
        <Navbar />
      </div>
    </div>
  );
}
